directive: fieldShowSidebar, but template was fieldsDisplaySidebarTemplate
<template>
  <div class="self-stretch flex-col gap-2 flex">
    <div v-if="field.type !== 'SectionLabel' && field.type !== 'FieldGroup'" class="self-stretch justify-start items-center gap-1 inline-flex">
      <div class="grow shrink tw-text-sm font-semibold">
        <span v-if="field.type==='DescriptiveText'" class="descriptive-text" v-html="$sanitize($tr(field.datahash, 'label'))"></span>
        <span v-else>{{$tr(field.datahash, 'label')}}</span>
      </div>
    </div>
    <template v-if='field.type !== "FieldGroup"'>
      <component :is="componentName" :form_preview="form_preview" :index="index" :form="form" :form_result="form_result" :field="field" display_type="show" :sidebar="true" />
    </template>
    <template v-else>
      <component :is="componentName" :form_preview="form_preview" :cst="cst" :form="form" :form_result="form_result" :field="field" display_type="show" :sidebar="true" />
    </template>
  </div>
</template>
<script>
import Fields from '../../../../client/src/common/fields/_all_display_fields.js';

export default {
  name: 'FieldsDisplaySidebar',
  mixins: [Fields],
  props: {
    index: {type: Number, required: true},
    cst: {type: Object, required: true},
    field: {type: Object, required: true},
    form: {type: Object, required: true},
    form_result: {type: Object, required: true},
    form_preview: {type: Boolean},
  },

  computed: {
    componentName(){
      let str = null;
      const type = this.field.type.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()

      switch(type){
        case 'likert':
          str = `${type}_answer_display`
          break;
        default:
          str = `${type}_display`
      }

      return str
    }
  },
}
</script>